import { Suspense, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';

import API from './services/API';
import { setUser } from './store/authSlice';
import CONSTANT from './utils/constant';

import PrivateRoute from './components/routerHelper/PrivateRoute';
import PublicRoute from './components/routerHelper/PublicRoute';
import WithNavbar from './components/WithNavbar/WithNavbar';

import Login from './pages/Login/Login.lazy';
import Logout from './pages/Logout/Logout';
import TaiXe from './pages/TaiXe/TaiXe.lazy';
import DonHangTaiXe from './pages/DonHangTaiXe/DonHangTaiXe.lazy';
import LichTrinhTaiXe from './pages/LichTrinhTaiXe/LichTrinhTaiXe.lazy';
import KhachHang from './pages/KhachHang/KhachHang.lazy';
import DonHangKhachHang from './pages/DonHangKhachHang/DonHangKhachHang.lazy';
import VanHanh from './pages/VanHanh/VanHanh.lazy';
import QuanLyTaiKhoan from './pages/QuanLyTaiKhoan/QuanLyTaiKhoan.lazy';
import ThongTinTaiKhoan from './pages/ThongTinTaiKhoan/ThongTinTaiKhoan.lazy';

import './App.scss';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.getItem(CONSTANT.STORAGE_KEY.DRIVER_USER)) {
      API.me()
        .then((data) => {
          if (data.success) {
            dispatch(setUser(data.data));
          } else {
            dispatch(setUser(null));
          }
        })
        .catch(() => {});
    }
    window.addEventListener('storage', () => {
      if (!localStorage.getItem(CONSTANT.STORAGE_KEY.DRIVER_USER)) dispatch(setUser(null));
    });
  }, []);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <WithNavbar />
            </PrivateRoute>
          }
        >
          <Route path="/" element={<Navigate to="/tai-xe" replace />} />
          <Route path="/tai-xe" element={<TaiXe />} />
          <Route path="/don-hang-tx" element={<DonHangTaiXe />} />
          <Route path="/lich-trinh-tx" element={<LichTrinhTaiXe />} />
          <Route path="/khach-hang" element={<KhachHang />} />
          <Route path="/don-hang-kh" element={<DonHangKhachHang />} />
          <Route path="/van-hanh-don" element={<VanHanh />} />
          <Route path="/quan-ly-tai-khoan" element={<QuanLyTaiKhoan />} />
          <Route path="/tt-tai-khoan" element={<ThongTinTaiKhoan />} />
          <Route path="/logout" element={<Logout />} />
          {/* <Route path="/not-found" element={<NotFound />} /> */}
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}

export default App;
